import { Injectable } from '@angular/core';
import { GridSettings } from '../_helpers/gridSettings';

@Injectable({
   providedIn: 'root',
})
export class StatePersistingService {
   public get<T>(token: string): T {
      const settings = localStorage.getItem(token);
      return settings ? JSON.parse(settings) : settings;
   }

   public set<T>(token: string, gridConfig: GridSettings): void {
      //
      //  const m = JSON.stringify(gridConfig);
      //  localStorage.setItem(token, JSON.stringify(gridConfig));
      const getCircularReplacer = () => {
         const seen = new WeakSet();
         return (key, value) => {
            if (typeof value === 'object' && value !== null) {
               if (seen.has(value)) {
                  return;
               }
               seen.add(value);
            }
            return value;
         };
      };

      localStorage.setItem(token, JSON.stringify(gridConfig, getCircularReplacer()));
   }
}
